import React from 'react';
import classNames from 'classnames';

import BackgroundImageContainer from '../BackgroundImageContainer';
import SectionTitle from '../SectionTitle';

import * as styles from './styles.module.scss';

const HeroStretch = (props) => {
  const {
    backgroundSize = null,
    children,
    className,
    description,
    hideBackground,
    hideBackgroundMobile,
    reverseBackground,
    subtitle,
    theme,
    title,
    titleClass,
    titleTag,
    type,
  } = props;

  return (
    <BackgroundImageContainer
      reverse={reverseBackground}
      theme={theme}
      hideBackground={hideBackground}
      hideBackgroundMobile={hideBackgroundMobile}
      size={backgroundSize}
      type={type}
    >
      <div className={classNames(styles.layout, className)}>
        <SectionTitle
          className={classNames(styles.title, titleClass)}
          description={description}
          subtitle={subtitle}
          tagType={titleTag}
          title={title}
        />
        <div className={styles.children}>{children}</div>
      </div>
    </BackgroundImageContainer>
  );
};

export default HeroStretch;
